import React from "react";

export default function BxBxSun(props) {
  return (
    <svg
      focusable="false"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993S6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007S8.993 13.658 8.993 12S10.342 8.993 12 8.993zM10.998 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2h-3zm17 0h3v2h-3z"
        fill="currentColor"
      ></path>
      <path
        d="M4.219 18.363l2.12-2.122l1.415 1.414l-2.12 2.122z"
        fill="currentColor"
      ></path>
      <path
        d="M16.24 6.344l2.122-2.122l1.414 1.414l-2.122 2.122z"
        fill="currentColor"
      ></path>
      <path
        d="M6.342 7.759L4.22 5.637l1.415-1.414l2.12 2.122z"
        fill="currentColor"
      ></path>
      <path
        d="M19.776 18.364l-1.414 1.414l-2.122-2.122l1.414-1.414z"
        fill="currentColor"
      ></path>
    </svg>
  );
}
